import { requestWithToken } from '../utilities/request';

const path = '/api/private/fields/';

const managerCount = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}${fieldId}/daily_worker_informations/cumulative_manager_count`,
    params,
  });
};

const registerManagerCount = (fieldId, params) => {
  return requestWithToken({
    method: 'POST',
    url: `${path}${fieldId}/daily_worker_informations`,
    data: params,
    validateStatus(status) {
      // Reject only if the status code 400
      return status === 400 || status === 200;
    },
  });
};

const updateManagerCount = (fieldId, params) => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}${fieldId}/daily_worker_informations/update`,
    data: params,
  });
};

export const DailyWorkInformationService = {
  managerCount,
  registerManagerCount,
  updateManagerCount,
};

export default DailyWorkInformationService;



// WEBPACK FOOTER //
// ./src/services/DailyWorkInformation.js